<template>
  <BreadCrumb />

  <ParagraphCustom :title="this.leafShapeTitle">
    <p>{{ leafShapeSubtitle }}</p>
  </ParagraphCustom>
  <div class="plant-image-base">
    <img
      src="@/assets/identify/shape_arrangement.png"
      class="shape"
      img-alt="image plant"
    />
  </div>

  <ParagraphCustom :title="this.leafArrangementTitle" color="secondary">
    <p>{{ leafArrangementSubtitle }}</p>
  </ParagraphCustom>
  <div class="plant-image-base">
    <div
      v-for="leafArrangement in leafArrangements"
      :key="leafArrangement"
      class="plant-image-base-item"
    >
      <img
        :src="getImgArrangementLeaf(leafArrangement.title)"
        class="plant-image"
        img-alt="image plant"
      />
      <div>{{ leafArrangement.title }}</div>
    </div>
  </div>

  <ParagraphCustom :title="this.leafMarginTitle">
    <p>{{ leafMarginSubtitle }}</p>
  </ParagraphCustom>
  <div class="plant-image-base">
    <div
      v-for="leafMargin in leafMargins"
      :key="leafMargin"
      class="plant-image-base-item"
    >
      <img
        :src="getImgMarginLeaf(leafMargin.title)"
        class="margin"
        img-alt="image plant"
      />
      <div>{{ leafMargin.title }}</div>
    </div>
  </div>

  <ParagraphCustom color="secondary">
    <div class="plant-text">Sources:</div>
    <a href="https://en.wikipedia.org/wiki/Glossary_of_leaf_morphology"
      >https://en.wikipedia.org/wiki/Glossary_of_leaf_morphology</a
    >
  </ParagraphCustom>
</template>
<script>
import BreadCrumb from "../BreadCrumb/BreadCrumb.vue";

import ParagraphCustom from "../ParagraphCustom.vue";
export default {
  name: "IdentifyPage",
  components: { ParagraphCustom, BreadCrumb },
  data() {
    return {
      leafShapeTitle: "Leaf Shape",
      leafShapeSubtitle: `Collectively, trees display scores of different leaf shapes and a
            wide range of sizes, from less than an inch to more than a yard.
            Broadleaf trees display the greatest variation in shape, but many
            are either elliptic or obovate. Conifer leaves tend to fall into
            just a few main categories: scalelike; linear; or needlelike and
            tapering to a pointed, but not always sharp, end.`,
      leafArrangementTitle: "Leaf Arrangement",
      leafArrangementSubtitle: `After assessing whether leaves are deciduous or overgreen, the way
            the leaves are arraenged on the shoot is a helpful aid to
            identification. Some trees have large leaves that are divided into
            smaller leaves, or leaflets. These are coumpound, and the
            arrangement of the leaflets provides another clue to identification.
            Pinnate leaves have leaflets on either side leaflets arranged like
            fingers on a hand. Leaves are called simple. Simple leaves may be
            arranged opposite each other on the stalk or may be alternate.`,
      leafArrangements: [
        { title: "Opposite" },
        { title: "Alternate" },
        { title: "Palmate" },
        { title: "Pinnate" },
      ],
      leafMarginTitle: "Leaf Margin",
      leafMarginSubtitle: `The margins of both compound and simple leaves may be smooth (known as entire) 
      or may have indentations. The leaf margin indentations may be wavy, serrated ot toothed 9like the teeth of a saw), or lobed.
      One of the most recognizable leaf margins is that of the commun oak, which has regular 'bites' along the margin
       interpersed with rounded lobes. Some leaves are also recognizable by their texture.
      For example, leaves ot the English elm have a rough texture, whereas those of the katsura tree are velvetlike.`,
      leafMargins: [
        { title: "Entire" },
        { title: "Lobed" },
        { title: "Toothed" },
        { title: "Wavy" },
      ],
    };
  },
  methods: {
    getImg: function (img) {
      return process.env.VUE_APP_URL_IMAGE + img;
    },
    getImgArrangementLeaf: function (img) {
      return require("@/assets/identify/arrangement/" + img + ".jpg");
    },
    getImgMarginLeaf: function (img) {
      return require("@/assets/identify/margin/" + img + ".jpg");
    },
  },
};
</script>
<style lang="scss" scoped>
.plant-image-base {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  margin-bottom: 2rem;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  @media (min-width: $constraint-width-medium) {
    flex-direction: row;
  }
}
.plant-image-base-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.shape {
  width: 100%;
}
.margin {
  max-width: 10rem;
}
.plant-text {
  word-wrap: break-word;
}
</style>
